import { listboxStyles as c } from "./listbox.styles.js";
import { FASTSelect as n, selectTemplate as r } from "@matrix42/fast-foundation";
import { Icon as s } from "../icon/index.js";
import { ListboxValues as a } from "./values/index.js";
const e = class e extends n {
  constructor() {
    super(), this._openIndicatorIcon = new s("chevron-down"), this._closeIndicatorIcon = new s("chevron-up"), this._selectedValues = new a(), Object.defineProperty(this, "collapsible", {
      value: !0
    });
  }
  selectedOptionsChanged(l, o) {
    var t;
    super.selectedOptionsChanged(l, o), this.multiple ? (this._selectedValues && !this._selectedValues.parentElement && this.insertBefore(this._selectedValues, this.firstChild), this._selectedValues.setValues(this.selectedOptions)) : (t = this._selectedValues) != null && t.parentElement && this.removeChild(this._selectedValues);
  }
  //TODO refactor to use indicator option of template
  connectedCallback() {
    super.connectedCallback(), this._openIndicatorIcon.classList.add("open-indicator"), this._openIndicatorIcon.setAttribute("slot", "indicator"), this._selectedValues.setAttribute("slot", "selected-value"), this._closeIndicatorIcon.classList.add("close-indicator"), this._closeIndicatorIcon.setAttribute("slot", "indicator"), this.insertBefore(this._openIndicatorIcon, this.firstChild), this.multiple && this.insertBefore(this._selectedValues, this.firstChild), this.insertBefore(this._closeIndicatorIcon, this.firstChild);
  }
};
e.definition = {
  name: "listbox",
  template: () => r(),
  styles: c
};
let i = e;
export {
  i as Listbox
};
